<template>
  <div class="flex flex-col items-center justify-center min-h-screen">
    <Header />
     
    <br />
    <main class="w-full max-w-6xl -mt-16 md:-mt-24 px-4 sm:px-6 lg:px-8 relative z-20">
      <ProgrammeObjectives />
      <ProgrammeImplementation />
      <ProjectTimeline />
      <RegistrationForm />
      
      <!-- Navigation to Registered Users Page -->
      <!---<section class="py-12 text-center">
        <div class="card p-8">
          <h3 class="text-2xl font-bold text-gray-800 mb-4">View Registered Users</h3>
          <p class="text-gray-600 mb-6">Access the complete list of registered participants with advanced search and filtering options.</p>
          <router-link 
            to="/registered-users" 
            class="inline-flex items-center px-6 py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 transition-colors shadow-md"
          >
            <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            View Registered Users
          </router-link>
        </div>
      </section> -->
    </main>
    
    <Footer />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';

const Header = defineAsyncComponent(() => import('../components/Header.vue'));
const RegistrationForm = defineAsyncComponent(() => import('../components/RegistrationForm.vue'));
const ProgrammeObjectives = defineAsyncComponent(() => import('../components/ProgrammeObjectives.vue'));
const ProgrammeImplementation = defineAsyncComponent(() => import('../components/ProgrammeImplementation.vue'));
const ProjectTimeline = defineAsyncComponent(() => import('../components/ProjectTimeline.vue'));
const Footer = defineAsyncComponent(() => import('../components/Footer.vue'));

export default {
  name: 'Home',
  components: {
    Header,
    RegistrationForm,
    ProgrammeObjectives,
    ProgrammeImplementation,
    ProjectTimeline,
    Footer
  }
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
body {
  font-family: 'Inter', sans-serif;
  background-color: #f0f4f8; /* A light, clean background */
  color: #1a202c;
}
.section-heading {
  position: relative;
  padding-bottom: 0.5rem;
}
.section-heading::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 4px;
  background-color: #10B981;
  border-radius: 9999px;
}
.card {
  background-color: #ffffff;
  border-radius: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05), 0 10px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 25px rgba(0, 0, 0, 0.15);
}
</style>